import { useState } from 'react';
import MainLayout from '../layout/MainLayout'
import UnitSearch from '../components/Qr/SearchByUnit';
import Scanner from '../pages/Scanner';
const QrPage = () =>{

    const [active,setActive] = useState(1)

    return(
        <MainLayout>
            <div className='p-5 text-center'>
                <h3 className='text-xl font-bold'>Carian Pelanggan</h3>
                <div className='flex justify-center items-center my-3'>
                    <button className={`rounded-lg font-medium py-2 px-3 ${active === 1 ? "bg-blue-500 text-white":"text-blue-500 bg-white border border-blue-500"}`} onClick={()=>setActive(1)} >Cari Unit</button>

                    <button className={`rounded-lg py-2 px-3 font-medium ms-2 ${active === 2 ? "bg-blue-500 text-white":"text-blue-500 bg-white border border-blue-500"}`} onClick={()=>setActive(2)} >Imbas QR</button>

                </div>

                {active === 1 ? <UnitSearch/> : <Scanner/>}
                
            </div>
        </MainLayout>
    );
}
export default QrPage;